import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-delegate-confirmation',
  templateUrl: './modal-delegate-confirmation.component.html',
  styleUrls: ['./modal-delegate-confirmation.component.css']
})
export class ModalDelegateConfirmationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalDelegateConfirmationComponent> , public dialog: MatDialog) { }
  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
  ngOnInit() {
  }

}
